import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faArrowRight, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface CardProps {
  icon: IconDefinition | string;
  title: string;
  description?: string;
  features: string[];
  badge?: string;
  badgeType?: 'default' | 'popular' | 'free' | 'subsidized';
  featured?: boolean;
}

export const Card: React.FC<CardProps> = ({
  icon,
  title,
  description,
  features,
  badge,
  badgeType = "default",
  featured = false,
}) => {
  /* tailwind */
  const badgeClasses = {
    default: "",
    popular: "bg-gradient-warm",
    free: "bg-gradient-warm",
    subsidized: "bg-gradient-cool text-white"
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div
      className={`h-full flex flex-col bg-white p-6 rounded-3xl 
        shadow-md transition will-change-transform relative overflow-hidden
        hover:shadow-xl 
    ${
      featured ? "border-2 border-primary-blue hover:border-primary-yellow" : ""
    }`}
    data-aos="fade-up"
      data-aos-delay="100"
    >
      {/* Header Section */}
      <div className="flex justify-between items-start mb-6 bg-gray-50 rounded-2xl p-4 -mx-2 -mt-2">
        <div className="flex-1">
          <h3 className="text-xl font-bold text-gray-900 mb-1">
            {title}
          </h3>
          {description && (
            <p className="text-sm text-gray-600">
              {description}
            </p>
          )}
        </div>
        <div className="w-10 h-10 bg-gradient-primary rounded-full flex items-center justify-center flex-shrink-0 ml-4">
          <FontAwesomeIcon
            className="text-lg text-white"
            icon={icon as IconDefinition}
          />
        </div>
      </div>

      {/* Accomplishment Section */}
      <div className="mb-4">
        <div className="space-y-0">
          {features.map((feature, index) => (
            <div key={index}>
              <div className="flex items-center justify-between py-3">
                <span className="text-gray-900 text-sm flex-1 pr-4">{feature}</span>
              </div>
              {index < features.length - 1 && (
                <div className="border-t border-gray-200"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
